export default __webpack_public_path__ + "static/media/91.10013861.png";